export default __webpack_public_path__ + "static/media/02.bcc8c1c0.jpg";